<template>
  <div class="sign-index">
    <div
      class="sign-router"
      :class="{ 'box3': list.length == 3, 'box4': list.length == 4, 'ok-style': $tools.isOKbao(stepConfig.merchantNo) || $tools.isOKTX(stepConfig.merchantNo) }"
    >
      <div :class="[{ active: item.index <= sign_index }, 'sign-router-li']" v-for="(item, i) in list" :key="i">
        <div class="sign-router-num">
          <span :class="[{ active: item.index == sign_index }, 'rign-router-num-box']">
            <span class="sigh-router-num-num" v-show="item.index >= sign_index">{{ i + 1 }}</span>
            <i class="iconfont icon-tongguo" v-show="item.index < sign_index"></i>
          </span>

          <span class="sign-router-line" v-if="i > 0"></span>
        </div>
        <div :class="[{ active: item.index == sign_index }, 'sign-router-title']">
          {{ item.name }}
        </div>
      </div>
    </div>
    <router-view :stepConfig="stepConfig" v-if="stepConfig.id" />
  </div>
</template>
<script>
//当前实例组件
export default {
  name: 'indexBox',
  data() {
    return {
      orgId: '',
      stepConfig: {},
      list: [],
      sign_index: 0,
      // statusRout: ['/sign/register', '/sign/face', '/sign/contract', '/sign/write', '/sign/train']
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.sign_index = to.meta.index;
    next();
  },
  mounted() {
    this.orgId = this.$route.query.orgId;
    this.sign_index = this.$route.meta.index || 0;
    this.getStep();
    this.$weixin.hideMenu();
  },
  methods: {
    getStep() {
      this.$http({
        type: 'GET',
        url: '/api/userAuth/v2/entry/steps',
        data: {
          orgId: this.orgId
        }
      }).then(res => {
        this.stepConfig = res.data;
        const list = [
          {
            name: '登记信息',
            show: '1',
            index: 0
          },
          {
            name: '人脸识别',
            show: res.data.isFaceAuth,
            index: 1
          },
          {
            name: '签署合同',
            show: res.data.isSignContract,
            index: 2
          },
          {
            name: '岗前培训',
            show: res.data.isTrain,
            index: 3
          }
        ];
        this.list = list.filter(item => item.show * 1);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.sign-index {
  min-height: 100vh;
  background-color: #fff;
}
.sign-blank {
  width: 100%;
  height: 20px;
  background-color: #f5f5f5;
}
.sign-router {
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fff;
  &.box3 {
    .sign-router-li .sign-router-num .sign-router-line {
      width: 200px;
    }
  }
  .sign-router-li {
    width: 33.3%;
    text-align: center;
    padding: 30px 20px;
    .sign-router-title {
      font-size: 26px;
      color: #888;
      &.active {
        color: #236dff;
        font-weight: 600;
      }
    }
    .sign-router-num {
      position: relative;
      width: 40px;
      height: 40px;
      display: block;
      margin: 0 auto;
      color: #fff;
      margin-bottom: 20px;
      .rign-router-num-box {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        background-color: #cfd0d5;
        border-radius: 50%;
        z-index: 3;
        &.active {
          background-color: #236dff;
          color: #fff;
        }
        &.active:after {
          content: '';
          position: absolute;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          border: 1px solid #236dff;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
        .icon-tongguo {
          font-size: 24px;
          font-weight: 900;
          transform: scale(0.7);
          display: block;
        }
      }
      .sign-router-line {
        position: absolute;
        top: 20px;
        right: 0.6rem;
        width: 1.8rem;
        height: 1px;
        background-color: #cfd0d5;
        z-index: 2;
      }
    }
  }
  .sign-router-li.active {
    .rign-router-num-box {
      background-color: #e1ebff;
      color: #236dff;
    }
    .sign-router-line {
      background-color: #236dff;
    }
    .sign-router-title {
      color: #236dff;
    }
  }
}
.ok-style {
  .sign-router-li {
    .sign-router-title {
      &.active {
        color: #ff8b00;
        font-weight: 400;
      }
    }
    .sign-router-num {
      .rign-router-num-box {
        &.active {
          background-color: #ff8b00;
        }
        &.active:after {
          border: 1px solid #ff8b00;
        }
      }
    }
  }
  .sign-router-li.active {
    .rign-router-num-box {
      color: #ff8b00;
      background-color: #ffebcb;
    }
    .sign-router-line {
      background-color: #ff8b00;
    }
    .sign-router-title {
      color: #ff8b00;
    }
  }
}
</style>
